if (!customElements.get('shop-impact-hero')) {
  customElements.define(
    'shop-impact-hero',
    class ShopImpactHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-shop-impact-slide]'));
        this.prevButton = this.querySelector('[data-shop-impact-prev]');
        this.nextButton = this.querySelector('[data-shop-impact-next]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.delay = Number(this.dataset.autoplayDelay) || 6000;
        this.autoplay = this.dataset.autoplay === 'true';

        this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1, true));
        this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1, true));

        this.querySelectorAll('[data-shop-impact-media]').forEach((media) => {
          const video = media.querySelector('video');
          if (!video) return;

          media.addEventListener('mouseenter', () => {
            media.classList.add('is-playing');
            video.play().catch(() => {
              media.classList.remove('is-playing');
            });
          });

          media.addEventListener('mouseleave', () => {
            video.pause();
            video.currentTime = 0;
            media.classList.remove('is-playing');
          });
        });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      goTo(index, userInitiated = false) {
        if (this.slides.length < 2) return;

        this.slides[this.index]?.classList.remove('is-active');
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides[this.index]?.classList.add('is-active');

        this.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.currentTime = 0;
          video.closest('[data-shop-impact-media]')?.classList.remove('is-playing');
        });

        if (userInitiated) this.start();
      }

      start() {
        this.stop();
        if (!this.autoplay || this.slides.length < 2) return;
        this.timer = window.setInterval(() => this.goTo(this.index + 1), this.delay);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  );
}
